import React, { useState, useEffect, CSSProperties } from 'react';
import { v4 as uuid } from 'uuid';
import { CartTotalSummaryTitle, DiscountCodeLabelContainer } from '../style';
import {
  RowProductListContainerMini,
  SummaryLoadContainer,
  SummaryProductInfoMini,
  SummaryProductImageMini,
  QuantityDot,
  SummaryProductScrolledContainer
} from '../../SummaryProductList/style';
import CurrencyFormat from '../../../utils/currencyFormat';
import { findAmountProduct, viewDiscountAmount, viewDiscountTab} from '../../../utils/formatData';
import Spinner from '../../Spinner';
import { Label } from "@material-ui/icons";
import { totalQuantityPrice } from '../../../utils/formatData';
import { language } from '../../../utils/language';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/reducers/index';

interface CartProductSummaryProps {
  data: any[];
  color: string;
  loading: boolean;
  productRowStyle?: CSSProperties;
  totalAmount: number;
  appliedCoupons: Coupon[];
}


const CartProductSummary = ({
  data,
  color,
  loading,
  totalAmount = 0,
  appliedCoupons
}: CartProductSummaryProps) => {
  const [items, setItems] = useState<any>([]);
  const [currentPosition, setCurrentPosition] = useState<number>(0);
  const homeState: HomeStateType = useSelector(
    (state: RootState) => state.home
  );

  const imgStyles: React.CSSProperties = {
    maxWidth: '80px !important',
    maxHeight: '80px !important',
  };


  const mappingImgRef = (img: string, imgProduct: string) => {
    return img !== '' ? img : imgProduct;
  };

  const returnProductQuantity = (product: any) => {
    if (product.references && product.references.length > 0) {
      return product.references[0].quantity;
    }
    return product.quantity;
  };

  useEffect(() => {
    const productsRefs= data.filter((item: any) => item.references && item.references.length > 0)
    const productsData = data.filter((item: any) => !(item.references && item.references.length > 0))
    if (productsRefs.length > 0) {
        productsRefs.map((product: any) => {
            product.references.map((itemRef: any) => {
                itemRef.data = product.productData.references.find( (field: any) => field.id === itemRef.id)
                productsData.push({ ...product, references: [itemRef] })
            })    
        })
    }
    setItems(productsData)

}, [data])

const getImageSrc = (product: any, mappingImgRef: Function) => {
  if (product.references && product.references.length > 0 && !product.references[0].data.img.endsWith('/null')) {
    return mappingImgRef(product.references[0].data.img, product.productData.img[0]) || product.productData.img[0];
  } else {
    return product.productData.img[0];
  }
}
  
  return (
    <>
      <CartTotalSummaryTitle>
        {language[homeState.default_language]["products2"]}
      </CartTotalSummaryTitle>

      <SummaryProductScrolledContainer className='product-summary-container'>
        {items.map((product: any, index: number) => {
          return (
            <RowProductListContainerMini id="product-row-mini" key={uuid()}>
              {loading && product.position === currentPosition ? (
                <SummaryLoadContainer>
                  <Spinner color={color} />
                </SummaryLoadContainer>
              ) : (
                <>
                  <SummaryProductImageMini style={imgStyles}>
                    <QuantityDot color={color}>
                      {returnProductQuantity(product)}
                    </QuantityDot>
                    <img
                      src={getImageSrc(product, mappingImgRef)} 
                      alt={getImageSrc(product, mappingImgRef)}
                    />
                  </SummaryProductImageMini>
                  <SummaryProductInfoMini
                    hasDiscount={findAmountProduct(product, 'discountRate') > 0}
                  >
                    <div className="summary-product-title-mini">
                      <div>
                      <p style={{"textAlign":"left"}} dangerouslySetInnerHTML={{ __html: product.productData.title.match(new RegExp(`.{1,20}`, 'g')).join('<br />') }} />
                      {product.references &&
                          product.references.length > 0 && (
                            <div className="summary-product-subTitle">
                              <p className="summary-product-reference-title">
                                {product.references[0].data.title}
                              </p>
                            </div>
                          )}
                           <div className='discount-labels-product'>
                            {/* {DiscountCodeLabelContainer} */} 
                            {appliedCoupons.map((coupon, index) => {
                              return viewDiscountTab(product, coupon, totalAmount, appliedCoupons) ? (
                                <DiscountCodeLabelContainer key={index} color={color}>
                                  <Label className={`discount-code__label-icon`} />
                                  {/* Discount Code Name */}
                                  <span className={`discount-code__name`}>
                                    {coupon.code}
                                  </span>
                                </DiscountCodeLabelContainer>
                              ) : <></>})}
                          </div>


                      </div>
                    </div>
                    <div></div>

                    {
                            /* TODO calcular y sumar su impuesto despues de aplicar codigo de descuento */
                      parseFloat(viewDiscountAmount(product,appliedCoupons,totalAmount).toString()) > 0 ?
                      <div style={{display: "flex", flexDirection: "column"}}>

                          <div className="summary-product-discount-mini">
                              <CurrencyFormat amount={totalQuantityPrice(product) - parseFloat(viewDiscountAmount(product,appliedCoupons,totalAmount).toString())}  />
                          </div>

                          <div className="summary-product-normalPrice-canceled">
                              <CurrencyFormat amount={totalQuantityPrice(product)} />
                          </div>    

                      </div>
                      :
                      <div className="summary-product-normalPrice-mini">
                          <CurrencyFormat amount={totalQuantityPrice(product)} />
                      </div>
                    }
                  </SummaryProductInfoMini>
                </>
              )}
            </RowProductListContainerMini>
          );
        })}
      </SummaryProductScrolledContainer>
    </>
  );
};

export default CartProductSummary;
